import { Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";

import { Button } from "../../../../components/Button";
import { DialogFooter } from "../../../../components/DialogFooter";
import { ShieldIcon } from "../../../../EmergencyCredits/components/ShieldIcon";

interface CancelShiftFooterProps {
  variant: "preview-credit" | "cancel-shift";
  onKeepShift: () => void;
  onPressAndHoldToCancel: () => void;
  onPreviewCredit: () => void;
  isLoading?: boolean;
}

export function CancelShiftFooter(props: CancelShiftFooterProps): JSX.Element {
  const {
    variant,
    onKeepShift,
    onPressAndHoldToCancel,
    onPreviewCredit,
    isLoading = false,
  } = props;

  const isPreviewCreditVariant = variant === "preview-credit";

  return (
    <DialogFooter orientation="vertical" sx={{ marginTop: "auto" }}>
      <Stack spacing={3} sx={{ width: "100%" }}>
        {isPreviewCreditVariant ? (
          <Button
            fullWidth
            variant="contained"
            size="large"
            disabled={isLoading}
            onClick={onPreviewCredit}
          >
            <Stack direction="row" spacing={4} alignItems="center">
              <ShieldIcon variant="filled" sx={{ fontSize: 16 }} />
              <Text color="inherit">Preview my cancellation credit</Text>
            </Stack>
          </Button>
        ) : (
          <Button
            fullWidth
            variant="outlined"
            size="large"
            disabled={isLoading}
            sx={(theme) => ({
              color: theme.palette.error.main,
              borderColor: theme.palette.border?.primary,
            })}
            onClick={onPressAndHoldToCancel}
          >
            Press and hold to cancel
          </Button>
        )}
        <Button
          fullWidth
          variant="outlined"
          size="large"
          disabled={isLoading}
          sx={(theme) => ({
            color: theme.palette.text.primary,
            borderColor: theme.palette.border?.primary,
          })}
          onClick={onKeepShift}
        >
          Keep my shift
        </Button>
      </Stack>
    </DialogFooter>
  );
}
